<template>
  <div class="countdown-widget-editor">
    <controller-section title="Position" :start-visible="true">
      <div class="control-row">
        <controller field-name="rotate" :value="values.rotate" prepend-icon="arrows-rotate" @input="updateModel"></controller>
      </div>
      <x-y-axis-widget-controllers @update="updateModel" :values="values"></x-y-axis-widget-controllers>
    </controller-section>
    <div class="control-row">
      <controller field-name="date" :value="values.date" append="" input-type="date" @input="updateModel"></controller>
    </div>
    <div class="z-index">
      Z-Index:
      <b-form-input type="number" v-model="values.zIndex" size="sm" @input="updateModel('zIndex', $event)"></b-form-input>
    </div>
  </div>
</template>
<script>

import Controller from '../Controller.vue';
import ControllerSection from '../ControllerSection.vue';
import XYAxisWidgetControllers from '../XYAxisWidgetControllers.vue';

export default {
  name: 'CountdownWidgetEditor',
  components: {
    Controller,
    ControllerSection,
    XYAxisWidgetControllers,
  },
  props: {
    values: {},
  },
  methods: {
    updateModel(field, value) {
      this.$emit('update', field, value);
    },
  },
};
</script>

<style lang="scss" scoped>
.countdown-widget-editor {
  .control-row {
    display: flex;
    justify-content: space-between;
    margin-top: 12px;
    &:first-of-type {
      margin-top: 0px;
    }
    align-items: center;
    div {
      &:not(:last-of-type) {
        margin-right: 10px;
      }
    }
  }
}
</style>
